"use client";

import { c as _c } from "react/compiler-runtime";
import type { Filter, FilterValue } from "../types/filter";
import type { Option } from "../types/filtermenu";
import { useFilterSearchState } from "./use-filtersearch-state";
const SPLIT_ONCE_AT = /:(.*)/g;

/**
 * Handles filter selection, deselection, URL synchronization, and legacy filter support.
 * @param filterTypes - Array of filter types to be managed
 */
export const useFilterActions = filterTypes => {
  const $ = _c(27);
  const [state, setState] = useFilterSearchState();
  let t0;
  if ($[0] !== filterTypes || $[1] !== state) {
    let t1;
    if ($[3] !== state) {
      t1 = filterType => getValue(filterType, state[filterType]);
      $[3] = state;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = filterTypes.flatMap(t1).filter(Boolean);
    $[0] = filterTypes;
    $[1] = state;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const activeFilters = t0 as Option[];
  let t1;
  if ($[5] !== state) {
    t1 = function getValueForType(filterValue) {
      const [type, fValue] = filterValue.split(SPLIT_ONCE_AT);
      const value = fValue.replace(/,/g, "_IN_");
      const oldValue = state[type] ? state[type].split(",") : [];
      const newValue = oldValue.includes(value) ? oldValue.filter(e => e !== value) : [...oldValue, value];
      return {
        type,
        value: newValue.length ? newValue.join(",") : null
      };
    };
    $[5] = state;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const getValueForType = t1;
  let t2;
  if ($[7] !== filterTypes || $[8] !== setState || $[9] !== state) {
    t2 = async filterValues => {
      const newState = {
        ...state
      };
      for (const type_0 of filterTypes) {
        newState[type_0] = null;
      }
      for (const filterValue_0 of filterValues) {
        const [type_1, fValue_0] = filterValue_0.split(SPLIT_ONCE_AT);
        const value_0 = fValue_0.replace(/,/g, "_IN_");
        const existingValue = newState[type_1] ? newState[type_1].split(",") : [];
        newState[type_1] = [...existingValue, value_0].join(",");
      }
      await setState(newState);
    };
    $[7] = filterTypes;
    $[8] = setState;
    $[9] = state;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const setLocationFilters = t2;
  let t3;
  if ($[11] !== getValueForType || $[12] !== setState || $[13] !== state) {
    t3 = async filterValue_1 => {
      const {
        type: type_2,
        value: value_1
      } = getValueForType(filterValue_1);
      await setState({
        ...state,
        [type_2]: value_1
      });
    };
    $[11] = getValueForType;
    $[12] = setState;
    $[13] = state;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const toggleFilter = t3;
  let t4;
  if ($[15] !== filterTypes || $[16] !== setState || $[17] !== state) {
    t4 = async () => {
      const newState_0 = {
        ...state
      };
      for (const type_3 of filterTypes) {
        newState_0[type_3] = null;
      }
      await setState(newState_0);
    };
    $[15] = filterTypes;
    $[16] = setState;
    $[17] = state;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const clearFilter = t4;
  let t5;
  if ($[19] !== setState) {
    t5 = async () => {
      await setState(null);
    };
    $[19] = setState;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const clearAll = t5;
  let t6;
  if ($[21] !== activeFilters || $[22] !== clearAll || $[23] !== clearFilter || $[24] !== setLocationFilters || $[25] !== toggleFilter) {
    t6 = {
      clearAll,
      clearFilter,
      toggleFilter,
      activeFilters,
      setLocationFilters
    };
    $[21] = activeFilters;
    $[22] = clearAll;
    $[23] = clearFilter;
    $[24] = setLocationFilters;
    $[25] = toggleFilter;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};

/**
 * Transforms filter values into the correct format for the react-select component
 * @param filterValue - Array of filter values or undefined
 */
function getValue(filterType: Filter, filterValue: string | null): Option[] {
  if (!filterValue) {
    return [];
  }
  return filterValue.split(",").map(filterValueItem => {
    const value = filterValueItem.replace(/_IN_/g, ",");
    return {
      label: value,
      value: `${filterType}:${value}`,
      count: 0,
      order: 0
    };
  });
}